import { Link } from 'react-router';
import { useTranslate } from '../i18n/useTranslate';
import { useLandingItem } from './landing';

/** İzinsiz sayfa (SEOAI-47). Hangi iznin eksik olduğunu söyler — destek talebi kolaylaşır. */
export function ForbiddenView({ permission }: { permission: string }) {
  const t = useTranslate();
  const landing = useLandingItem();

  return (
    <section role="alert" className="error">
      <h1>{t('forbidden.title')}</h1>
      <p>{t('forbidden.body')}</p>
      <p>
        {t('forbidden.needed')} <code>{permission}</code>
      </p>
      {/*
        * Geri bağlantısı ERİŞİLEBİLİR bir hedefe gider. Sabit '/' idi ve o da
        * /projects'e yönlendiriyordu: izinsiz kullanıcı Forbidden → başa dön →
        * Forbidden döngüsüne giriyordu (inceleme bulgusu).
        */}
      {landing && <Link to={landing.to}>{t('forbidden.back')}</Link>}
    </section>
  );
}
